import { GroveMark } from "@/components/GroveMark";

const links = [
  { label: "Platform", href: "#platform" },
  { label: "Modules", href: "#modules" },
  { label: "Coverage", href: "#transparency" },
  { label: "Founder", href: "#founder" },
];

export const Navbar = () => {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-grove-ground/90 backdrop-blur-md border-b border-grove-bsub px-6 lg:px-12 py-4"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <a href="#" data-testid="brand-logo-link" className="flex items-center gap-3 group">
          <GroveMark />
          <span className="font-disp text-xl tracking-tight text-grove-ink font-semibold">
            equitygrove
          </span>
        </a>
        <div className="hidden md:flex items-center gap-8 text-xs font-mono uppercase tracking-widest text-grove-mute">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="hover:text-grove-deep transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>
        <a
          href="#contact"
          data-testid="nav-connect-founder-btn"
          className="inline-flex items-center justify-center px-4 py-2 text-xs font-mono tracking-widest uppercase bg-grove-deep text-white rounded hover:bg-grove-mid transition-colors shadow-sm"
        >
          Connect With Founder
        </a>
      </div>
    </nav>
  );
};
